import { render, staticRenderFns } from "./TestOrderLocListing.vue?vue&type=template&id=84f24902&"
import script from "./TestOrderLocListing.vue?vue&type=script&lang=js&"
export * from "./TestOrderLocListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports